import MENU_ITEMS from 'constants/menuItems';

const initialState = {
  isOpen: true,
  menuItems: MENU_ITEMS,
};

export default initialState;
